import { PrintOrientation } from '../types';
import { defaultStyles } from './defaultPrintStyles';
import { insertHeadElement } from './insertHeadElement';

/**
 * Injects the default styles into the printBody as a style tag
 * @param printBody - The document to inject the styles into
 * @param orientation - The orientation of the iframe
 * @param rootSize - The size of the frame in mm
 */
const injectDefaultStyles = (
  printBody: Document,
  orientation: PrintOrientation,
  rootSize?: { width: string; height: string }
) => {
  return insertHeadElement({
    printBody,
    tagName: 'style',
    text: defaultStyles(orientation, rootSize),
  });
};
export { injectDefaultStyles };
